<template>
    <div>
        <div class="modal fade resign-modal" :class="{'is-open': confirmModalOpen}">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="doUpdateStoreResign"><i class="icon-close"></i></button>
                        <h3 class="modal-title">該同仁的自招件預設調撥給增員者</h3>
                    </div>
                    <div class="modal-body">
                        <p><span class="normal-hight-text"><strong>增員者-{{ resignInfo.intr_ceclcno }}({{ resignInfo.intr_name }})</strong></span>；</p>
                        <p>若<span class="hight-text normal-hight-text"><strong>欲將自招件撥給非增員者</strong></span>，請依下列流程:</p>
                        <ul class="step-text">
                            <li>點選【解鎖自招件可撥給非增員者】選項</li>
                            <li>輸入原因</li>
                            <li>點選【解鎖】後即可作業</li>
                        </ul>
                    </div>
                    <div class="row">
                        <div class="col-12 text-right">
                            <button type="button" @click="reasonModalOpen = true" class="btn btn-default">解鎖自招件可撥給非增員者</button>
                            <button type="button" @click="doUpdateStoreResign" class="btn btn-primary">確認</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade resign-modal" :class="{'is-open': reasonModalOpen}">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="doCloseUnlockResignModal"><i class="icon-close"></i></button>
                        <h3 class="modal-title">解鎖自招件可撥給非增員者原因</h3>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row">
                            <label class="col-1 text-right pt-2">原因</label>
                            <div class="col-4">
                                <v-select
                                    data-vv-name="原因類別"
                                    :class="{ 'is-invalid': errors.has(`原因類別`) }"
                                    v-model="memoType"
                                    v-validate="'required'"
                                    :options="unlockOption"
                                    placeholder="請選擇"
                                    @input="doGetDefaultMemo"
                                ></v-select>
                            </div>
                            <div class="col-7">
                                <input v-model="memo" type="text" class="form-control">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-right">
                            <button v-if="page == 'submanger'" type="button" @click="reasonModalOpen = false" class="btn btn-default">回到上一步</button>
                            <button type="button" @click="doUnlock" class="btn btn-primary"> {{ page == 'manger' ? '解鎖' : '送出覆核' }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { doResignUnlock } from "@/service";
import VeeValidate, { Validator } from "vee-validate";
import zh_TW from "vee-validate/dist/locale/zh_TW";
import Vue from "vue";

Vue.use(VeeValidate);
Validator.localize("zh_TW", zh_TW);
const dictionary = {
  zh_TW: {
    messages: {
      required: field => `請選擇 ${field}`
    }
  }
};

Validator.localize(dictionary);
export default {
  name: "UnlockResignModal",
  props: {
    confirmModalOpen: {
      type: Boolean,
      default: false
    },
    resignInfo: {
      type: Object,
      require: true
    },
    page: {
      type: String,
      require: true
    }
  },
  computed: {
    /** 1: 專招, 4: 展業 */
    resignType: function() {
      return this.$store.state.userInfo.divNo.substring(2, 3);
    }
  },
  data() {
    return {
      reasonModalOpen: false,
      memoType: "",
      memo: "",
      unlockOption: [
        {
          label: "單位服務件資源",
          value: "1"
        },
        {
          label: "分配需求",
          value: "2"
        },
        {
          label: "自行輸入原因",
          value: "9"
        }
      ]
    };
  },
  methods: {
    /** 更新resign資料 */
    doUpdateStoreResign: function() {
      this.resignInfo.is_unlock = "N"
      this.$store.dispatch("updateIsQryResginUnlock", true);
      this.$store.dispatch("updateResignInfo", this.resignInfo);
      // 1: 專招
      if (this.resignType === "1") {
        this.$store.dispatch("updateIsResignType", true);
      }

      // 4: 展業
      if (this.resignType === "4") {
        this.$store.dispatch("updateIsResignType", false);
      }

      this.$emit("close-all");
    },
    /** 進行解鎖 */
    doUnlock: function() {
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }

        let pattern = /[<>!@#$^&,."'?%*;_()+-/{}[\]|~`=\\\s]/g;
        if (this.memo.match(pattern)) {
          this.$toast.info({ title: "請勿輸入特殊符號" })
          return;
        }

        const reqData = {
          resign_id: this.resignInfo.resign_id,
          intr_id: this.resignInfo.intr_id,
          page: this.page,
          agidno: this.$store.state.userInfo.id,
          memo_type: this.memoType.value,
          memo: this.memo
        };
        doResignUnlock(this.$store.state.userInfo.id, reqData).then(result => {
          if (result && result.header.status == "200" && result.body) {
            this.$toast.info({ title: "異動成功" });
            this.reasonModalOpen = false;
            this.memoType = "";
            this.memo = "";
            this.resignInfo.is_unlock = 'Y'
            this.$store.dispatch("updateIsQryResginUnlock", true);
            this.$store.dispatch("updateResignInfo", this.resignInfo);

            // 1: 專招
            if (this.resignType === "1") {
              this.$store.dispatch("updateIsResignType", true);
            }

            // 4: 展業
            if (this.resignType === "4") {
              this.$store.dispatch("updateIsResignType", false);
            }

            this.$emit("close-all");
          } else {
            this.$toast.info({ title: "異動失敗" });
          }
        });
      });
    },
    /** 關閉視窗 */
    doCloseUnlockResignModal: function() {
      this.reasonModalOpen = false;
      this.memoType = "";
      this.memo = "";
    },
    /**
     * 取得memo預設內容
     * @param {Object} obj 當前值
     */
    doGetDefaultMemo: function(obj) {
      this.memo = "";
      if (obj.value === "1") {
        this.memo = "單位服務件資源";
      }

      if (obj.value === "2") {
        this.memo = "分配需求";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.resign-modal > .modal-dialog > .modal-content > .modal-body {
  min-height: 200px;
}
.hight-text {
  color: red;
}
.normal-hight-text {
  text-decoration: underline;
}
.step-text {
  list-style-type: decimal;
}
</style>
